import React from 'react';
import useFeatureFlags from '../hooks/useFeatureFlags';

export type WithFeatureFlagsState = {
    featureFlags: Record<string, boolean>;
}

export default function withFeatureFlags<TProps>(
    WrappedComponent: React.ComponentType<TProps & WithFeatureFlagsState>
): React.FC<TProps> {
    return (props: TProps) => {
        const { featureFlags } = useFeatureFlags();
        return <WrappedComponent featureFlags={featureFlags} {...props} />;
    };
}